/**************************************************
 * Nombre:       Card_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {React} from 'react';
import {ButtonBase, Grid} from "@mui/material";
import {CardBase} from "../../Modulo_Tarjetas/Componentes/C_Cards";
import {Building, Buildings, Cake, Google, Message, Mobile, Money, Shop, User} from "iconsax-react";


const Tarjeta_Pqrs = ({valores, click}) => {


    return (
        <ButtonBase sx={{width: "100%", borderRadius: 0}} onClick={() => click(valores)}>
            <CardBase valores={valores} >

                <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                >

                    <Grid item lg={3} sm={5} xs={8}>
                        <CardBase.FechaComponente dato1={"fecha"} >
                            <CardBase.IconTexto Icono={User} dato1={"nombre"}/>
                        </CardBase.FechaComponente>
                    </Grid>

                    <Grid item lg={2} sm={4} xs={6} >
                        <CardBase.IconTexto Icono={Mobile} dato1={"celular"}/>
                    </Grid>

                    <Grid item lg={3} sm={5} xs={6} >
                        <CardBase.IconTexto Icono={Google} dato1={"correo"}/>
                    </Grid>

                    <Grid item lg={4} sm={3} xs={8} >
                        <CardBase.IconTextoParrafo Icono={Message} dato1={"mensaje"}/>
                    </Grid>



                </Grid>




        </CardBase>
</ButtonBase>
)
}

export default Tarjeta_Pqrs;